"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var classnames = require("classnames");
var ui_1 = require("@vidazoo/ui");
var TwoFaForm = /** @class */ (function (_super) {
    tslib_1.__extends(TwoFaForm, _super);
    function TwoFaForm(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.enableTwoFactoAuth = function () {
            var enableTwoFactoAuth = _this.props.enableTwoFactoAuth;
            enableTwoFactoAuth(_this.state.token);
        };
        _this.openPasswordMode = function () {
            _this.setState({ passwordMode: true });
        };
        _this.closePasswordModal = function () {
            _this.setState({ passwordMode: false, password: "" });
        };
        _this.disableTwoFactorAuth = function () {
            var _a = _this.props.twoFactorAuth, enableTwoFactorAuth = _a.enableTwoFactorAuth, enforce = _a.enforce;
            if (enableTwoFactorAuth && enforce) {
                // You can't disable 2FA if it's enforced.
                return;
            }
            var disableTwoFactorAuth = _this.props.disableTwoFactorAuth;
            disableTwoFactorAuth(_this.state.password);
            _this.closePasswordModal();
        };
        _this.genereateTwoFactorSecret = function () {
            var genereateTwoFactorSecret = _this.props.genereateTwoFactorSecret;
            genereateTwoFactorSecret(_this.state.password);
            _this.closePasswordModal();
        };
        _this.onChange = function (e) {
            var _a;
            var key = e.target.name;
            var value = e.target.value;
            _this.setState((_a = {}, _a[key] = value, _a));
        };
        _this.state = {
            token: "",
            password: "",
            passwordMode: false
        };
        return _this;
    }
    TwoFaForm.prototype.renderPasswordForm = function () {
        var twoFactorAuth = this.props.twoFactorAuth;
        var password = this.state.password;
        var text = twoFactorAuth.enableTwoFactorAuth ? "Disable Two Factor Authentication" : "Enable Two Factor Authentication";
        var onClick = twoFactorAuth.enableTwoFactorAuth ? this.disableTwoFactorAuth : this.genereateTwoFactorSecret;
        return (React.createElement(ui_1.Modal, { basic: true, exitOnClickOutside: false, onClose: this.closePasswordModal, windowStyle: { width: "46rem" } },
            React.createElement("h4", { className: theme.passwordModalTitle }, "Enter Your Current Password"),
            React.createElement(ui_1.FormInput, { type: "password", defaultValue: password, fill: true, name: "password", label: "Password", required: true, onChange: this.onChange }),
            React.createElement("div", { className: theme.options },
                React.createElement(ui_1.Button, { type: "button", medium: true, gray: true, onClick: this.closePasswordModal }, "Cancel"),
                React.createElement(ui_1.Button, { type: "button", medium: true, blue: true, onClick: onClick }, text))));
    };
    TwoFaForm.prototype.renderDataUrl = function () {
        var token = this.state.token;
        var dataUrl = this.props.dataUrl;
        return (React.createElement("div", { className: theme.verify },
            React.createElement(ui_1.Label, { className: theme.label, size: 12, uppercase: false },
                React.createElement("b", null, "1. Scan the code"),
                " - Using you two-factor app, scan the QR code below"),
            React.createElement("div", { className: theme.img },
                React.createElement("img", { src: dataUrl })),
            React.createElement(ui_1.Label, { className: theme.label, size: 12, uppercase: false },
                React.createElement("b", null, "2. Verify your app"),
                " - To enable two-factor authentication, enter your valifation code"),
            React.createElement(ui_1.FormInput, { defaultValue: token, fill: true, name: "token", label: "Validation Code", onChange: this.onChange, required: true, placeholder: "6 digit code" })));
    };
    TwoFaForm.prototype.renderForm = function () {
        var twoFactorAuth = this.props.twoFactorAuth;
        var enableTwoFactorAuth = twoFactorAuth.enableTwoFactorAuth, enforce = twoFactorAuth.enforce;
        var enabledAndEnforced = enableTwoFactorAuth && enforce;
        var iconName = enableTwoFactorAuth ? "icon-approved-status" : "icon-rejected-status";
        var iconColor = enableTwoFactorAuth ? "green" : "red";
        return (React.createElement("div", { className: classnames(theme.row, theme.form) },
            React.createElement("div", { className: theme.row },
                React.createElement(ui_1.Icon, { className: theme.icon, iconColor: iconColor, iconName: iconName, size: 3.6 }),
                React.createElement("label", { className: theme.statusLabel, style: { paddingTop: "0.8rem" } },
                    "Two Factor authentication is ",
                    enableTwoFactorAuth ? React.createElement("b", null, "enable") : React.createElement("b", null, "disabled"),
                    enabledAndEnforced ? React.createElement("div", { className: theme.enforced }, "2FA is set as required for your account") : null)),
            React.createElement(ui_1.Button, { type: "button", disabled: enabledAndEnforced, medium: true, blue: true, onClick: this.openPasswordMode }, enableTwoFactorAuth ? "Disable" : "Enable")));
    };
    TwoFaForm.prototype.render = function () {
        var _a = this.props, onCancel = _a.onCancel, dataUrl = _a.dataUrl;
        var _b = this.state, passwordMode = _b.passwordMode, token = _b.token;
        return (React.createElement(ui_1.Form, { className: theme.twoFa },
            !dataUrl ? this.renderForm() : this.renderDataUrl(),
            React.createElement("div", { className: theme.options },
                React.createElement(ui_1.Button, { type: "button", medium: true, gray: true, onClick: onCancel }, "Cancel"),
                dataUrl ?
                    React.createElement(ui_1.Button, { type: "button", medium: true, blue: true, disabled: !token, onClick: this.enableTwoFactoAuth }, "Enable Two Factor Authentication") : null),
            passwordMode ? this.renderPasswordForm() : null));
    };
    TwoFaForm.defaultProps = {
        dataUrl: ""
    };
    return TwoFaForm;
}(React.Component));
exports.default = TwoFaForm;
